<template>
  <div id="cesium-container" ref="cesiumContainer">
    <cesium-recorder ref="cesiumRecorder" />
  </div>
</template>

<script>
import { CesiumInitialization } from '../../components/ThreeD/CesiumInitialization'
import { GroundStation } from '../../components/ThreeD/GroundStation'
import { PointOfInterest } from '../../components/ThreeD/PointOfInterest'
import CesiumRecorder from '../../components/ThreeD/CesiumRecorder.vue'

export default {
  name: 'groundStation-cesium-viewer',
  mixins: [CesiumInitialization, GroundStation, PointOfInterest],
  props: ['gsData'],
  components: {
    'cesium-recorder': CesiumRecorder
  },
  watch: {
    gsData: {
      handler() {
        if (!isNaN(this.gsData.fieldOfViewRadius)) {
          this.updateFoVCircleRadius(this.gsData.fieldOfViewRadius)
        }
        if (!isNaN(this.gsData.longitude) && !isNaN(this.gsData.latitude)) {
          this.onCoordinatesChangedInForm({
            longitude: this.gsData.longitude,
            latitude: this.gsData.latitude
          })
          this.createEllipsePrimitive(this.gsData.fieldOfViewRadius, {
            longitude: this.gsData.longitude,
            latitude: this.gsData.latitude
          })
        }
      },
      deep: true
    }
  },

  mounted() {
    this.initializeViewer()
    this.insertElementInToolbar(this.$refs.cesiumRecorder.$el)
    this.deactivateControls()
    this.initializeCursorEntity()
    this.addFoVCircle(this.gsData.fieldOfViewRadius)
    this.onCoordinatesChangedInForm({
      longitude: this.gsData.longitude,
      latitude: this.gsData.latitude
    })
    this.initEllipsePC()
    this.createEllipsePrimitive(this.gsData.fieldOfViewRadius, {
      longitude: this.gsData.longitude,
      latitude: this.gsData.latitude
    })
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 999;
}
</style>
